// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__5i0MS","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2xhoB"};